import React, { useRef, useState } from 'react';
import { Viewer, Worker, ScrollMode, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';
import './previewer.css'

const LazyPdfViewer = () => {
    const pdfUrl = "https://pdf-edited-uat.s3.amazonaws.com/GlobalTemplates/Dummy2.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA266B5UOXJ6Q2AUO7%2F20250513%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250513T090018Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=2d227f74e445635576e48fab3f9c544c67a0f2034fb357d6be7713cb64421c0d";

    const thumbnailPluginInstance = thumbnailPlugin();

    return (
        <div style={{ display: 'flex', height: '100vh', background: "#ccc"}}>
            {/* Sidebar thumbnails */}
            <div style={{ width: '20%', overflowY: 'auto', borderRight: '1px solid #ccc' }}>
                <thumbnailPluginInstance.Thumbnails />
            </div>

            {/* Main PDF viewer */}
            <div style={{ flex: 1, overflow: 'hidden', }}>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                    <Viewer
                        fileUrl={pdfUrl}
                        defaultScale={SpecialZoomLevel.PageFit}
                        scrollMode={ScrollMode.Vertical}
                        plugins={[thumbnailPluginInstance]}
                    />
                </Worker>
            </div>
        </div>
    );
};

export default LazyPdfViewer;
